import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StuplayConfig } from '../stuplay-config';
import { Media } from "./media";

@Injectable()
export class MediaProvider {

    constructor(public http: HttpClient, private stuplayConfig: StuplayConfig) {}

    getMedias(type: string): Observable<any> {
        let data = {
            medias: [],
            pagination: {}
        };
        return this.http.get(`${this.stuplayConfig.envVar.API_URL}/folder/0?type=${type}`)
            .pipe(map((res: any) => {
                res.folder.medias.map((media) => {
                    data.medias.push(new Media(media, this.http, this.stuplayConfig))
                });
                data.pagination = res.pagination;
                return data;
            }));
    }

    getStatus(id: number): Observable<any> {
        return this.http.get(`${this.stuplayConfig.envVar.API_URL}/media/${id}/status`)
            .pipe(map((data) => new Media(data, this.http, this.stuplayConfig)));

    }

    getMedia(id: number): Observable<Media> {
        return this.http.get(`${this.stuplayConfig.envVar.API_URL}/media/${id}/show`)
            .pipe(map((data: any) => data.media));
    }

    loadMore(type: string, currentPage: number) {
        let data = {
            medias: [],
            pagination: {}
        };
        return this.http.get(`${this.stuplayConfig.envVar.API_URL}/folder/0?type=${type}&page=${currentPage}`)
            .pipe(map((res: any) => {
                res.folder.medias.map((media) => {
                    data.medias.push(new Media(media, this.http, this.stuplayConfig));
                });
                data.pagination = res.pagination;
                return data;
            }));
    }
}
